import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cloud-migration-assessments-dashboard',
  templateUrl: './cloud-migration-assessments-dashboard.component.html',
  styleUrls: ['./cloud-migration-assessments-dashboard.component.scss']
})
export class CloudMigrationAssessmentsDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
